module.exports = __webpack_public_path__ + "static/media/IIMG.5cfadb15.JPG";